// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__TMDRK","footer":"ModalFilter_footer__2qm82"};